import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    product: {},
    isMenuFormulaSaleOpen: false,
    menuFormulaIdsList: [],
    formulaPrincipalItemPrice: 0,
    initialItem: {},
    isBeforeMenu: false,
    isHaveOptionsToShow: false,
    formulaMenuTitle: "",
    activeSizeDialogProductId: "",
};

export const ProductSlice = createSlice({
    name: "ProductSlice",
    initialState,
    reducers: {
        SelectProduct: (state, action) => {
            state.product = action.payload;
            state.isMenuFormulaSaleOpen = false;
        },
        setMenuFormulaSaleData: (state, { payload }) => {
            state.isMenuFormulaSaleOpen = payload.isMenuFormulaSaleOpen;
            state.menuFormulaIdsList = payload.menuFormulaIdsList;
            state.formulaPrincipalItemPrice = payload.formulaPrincipalItemPrice;
            state.initialItem = payload.initialItem;
            state.isBeforeMenu = payload.isBeforeMenu;
            state.isHaveOptionsToShow = payload.isHaveOptionsToShow ?? false;
            state.formulaMenuTitle = payload.formulaMenuTitle;
        },
        resetMenuFormulaSale: (state) => {
            state.isMenuFormulaSaleOpen = false;
            state.menuFormulaIdsList = [];
            state.formulaPrincipalItemPrice = 0;
            state.initialItem = {};
            state.isBeforeMenu = false;
            state.isHaveOptionsToShow = false;
            state.formulaMenuTitle = "";
        },
        setActiveSizeDialogProductId(state, { payload }) {
            state.activeSizeDialogProductId = payload;
        },
    },
});

export const {
    SelectProduct,
    setMenuFormulaSaleData,
    resetMenuFormulaSale,
    setActiveSizeDialogProductId,
} = ProductSlice.actions;
export default ProductSlice.reducer;
